module.exports = __webpack_public_path__ + "fonts/d02d0d1.ttf";